import React from 'react';

const ArticleContent = ({ content }) => {
  return (
    <div 
      className="prose prose-slate max-w-none"
      style={{
        '--tw-prose-body': 'var(--color-card-foreground)',
        '--tw-prose-headings': 'var(--color-card-foreground)',
        '--tw-prose-links': 'var(--color-primary)',
        '--tw-prose-bold': 'var(--color-card-foreground)',
        '--tw-prose-quotes': 'var(--color-muted-foreground)',
        lineHeight: '1.8',
        fontSize: '1.0625rem'
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default ArticleContent;